import { useEffect, useRef } from "react";
import HomeDepotLogo from './compAssets/home_depot.avif';
import ChawlaLogo from './compAssets/Chawla.avif';
import McCormickLogo from './compAssets/McCormick Foundation.avif';
import ComEdLogo from './compAssets/ComEd.avif';
import AuroraLogo from './compAssets/City_Of_Aurora.jpg';
import DunhamLogo from './compAssets/Dunham_Foundation.png';
import GreaterChicagoLogo from './compAssets/Greater_Chicago.svg';
import BSA_Logo from './compAssets/BSA.png';
import NorthernIllinoisLogo from './compAssets/Northern_Illionis.png';

export const SponsorScroller = () => {
    const scrollRef = useRef([]);

    useEffect(() => {
        function animate() {
            scrollRef.current.forEach((scroller) => {
                if (!scroller) {
                    return;
                }

                scroller.setAttribute("data-animated", "true");

                const inScroller = scroller.querySelector(".scroller__inner");
                const children = Array.from(inScroller.children);
                
                children.forEach((child) => {
                    const clone = child.cloneNode(true);
                    clone.setAttribute("aria-hidden", "true");
                    inScroller.appendChild(clone);
                })
            });
        }
        animate();
    }, []);

    const sponsors = [
        {
            name: "Home Depot",
            logo: HomeDepotLogo,
            url: "https://www.homedepot.com/",
            alt: "Home Depot"
        },
        {
            name: "ComEd",
            logo: ComEdLogo,
            url: "https://www.comed.com/",
            alt: "ComEd"
        },
        {
            name: "Chawla & Associates",
            logo: ChawlaLogo,
            url: "https://chawlacpa.com/",
            alt: "Chawla & Associates"
        },
        {
            name: "McCormick Foundation",
            logo: McCormickLogo,
            url: "https://www.mccormickfoundation.org/",
            alt: "Rob R. McCormick Foundation"
        },
        {
            name: "City of Aurora",
            logo: AuroraLogo,
            url: "https://www.aurora.il.us/Home",
            alt: "City of Aurora"
        },
        {
            name: "Dunham Foundation",
            logo: DunhamLogo,
            url: "https://www.dunhamfoundation.org/",
            alt: "Dunham Foundation"
        },
        {
            name: "Greater Chicago Food Depository",
            logo: GreaterChicagoLogo,
            url: "https://www.chicagosfoodbank.org/",
            alt: "Greater Chicago Food Depository"
        },
        {
            name: "BSA",
            logo: BSA_Logo,
            url: "https://www.scouting.org/",
            alt: "BSA"
        },
        {
            name: "Northern Illinois Food Bank",
            logo: NorthernIllinoisLogo,
            url: "https://solvehungertoday.org/",
            alt: "Northern Illinois Food Bank"
        }
    ];

    return (
        <section className="bg-forest py-16 sm:py-24 px-6 relative overflow-hidden border-t border-forest_soft">
            <div className="max-w-7xl mx-auto relative z-10">
                <div className="text-center mb-12 sm:mb-16">
                    <p className="oli-label text-gold_soft mb-3">Our Partners</p>
                    <h2
                        className="font-display font-bold text-cream"
                        style={{ fontSize: 'var(--text-section)' }}
                    >
                        Growing alongside our community
                    </h2>
                </div>

                <div className="relative">
                    <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-forest to-transparent z-10 pointer-events-none"></div>
                    <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-forest to-transparent z-10 pointer-events-none"></div>

                    <div 
                        className="scroller w-full overflow-hidden" 
                        ref={(el) => (scrollRef.current[0] = el)}
                    >
                        <div className="scroller__inner flex gap-16 py-12 animate-scroll">
                            {sponsors.map((sponsor, index) => (
                                <a
                                    key={`${sponsor.name}-${index}`}
                                    href={sponsor.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="group flex-shrink-0 oli-paper rounded-card p-8 shadow-card hover:shadow-card-hover transition-all duration-300 border border-line hover:border-gold/60"
                                >
                                    <div className="flex flex-col items-center space-y-4">
                                        <div className="w-36 h-28 flex items-center justify-center">
                                            <img 
                                                src={sponsor.logo} 
                                                alt={sponsor.alt}
                                                className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500"
                                            />
                                        </div>
                                        <span className="text-base font-semibold text-ink group-hover:text-forest transition-colors duration-300 text-center">
                                            {sponsor.name}
                                        </span>
                                    </div>
                                </a>
                            ))}
                            {sponsors.map((sponsor, index) => (
                                <a
                                    key={`${sponsor.name}-duplicate-${index}`}
                                    href={sponsor.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="group flex-shrink-0 oli-paper rounded-card p-8 shadow-card hover:shadow-card-hover transition-all duration-300 border border-line hover:border-gold/60"
                                >
                                    <div className="flex flex-col items-center space-y-4">
                                        <div className="w-36 h-28 flex items-center justify-center">
                                            <img 
                                                src={sponsor.logo} 
                                                alt={sponsor.alt}
                                                className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500"
                                            />
                                        </div>
                                        <span className="text-base font-semibold text-ink group-hover:text-forest transition-colors duration-300 text-center">
                                            {sponsor.name}
                                        </span>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
